/**
 * This file is loaded after the Boost PFS JS file.
 */
(function () {
  if (typeof window.chdProductTitleForDisplay !== 'function') {
    window.chdProductTitleForDisplay = function (title) {
      if (title == null || typeof title !== 'string') return title;
      var t = title;
      var subs = ['• Chr. Jørgensen', '•Chr. Jørgensen', ' · Chr. Jørgensen', '· Chr. Jørgensen', ' | Chr. Jørgensen'];
      for (var si = 0; si < subs.length; si++) {
        t = t.split(subs[si]).join('');
      }
      t = t.replace(/\s*[\u2022\u00B7|]\s*Chr\.\s*Jørgensen/gi, '');
      var chdSeriesNames = ['Søllerød', 'Nyholm', 'Nyboder', 'Nørrebro', 'Marielund', 'Ryvang', 'Langelinie', 'Hasseris', 'Holmen', 'Frederiksberg', 'Østerbro', 'Trianglen', 'Kastellet', 'Rungsted', 'Vesterbro', 'København', 'Trørød', 'Værløse', 'Klampenborg', 'Skagen', 'Lyngby'];
      for (var ci = 0; ci < chdSeriesNames.length; ci++) {
        var sn = chdSeriesNames[ci];
        var suff = [' \u2013 ' + sn, ' - ' + sn, '- ' + sn];
        for (var sj = 0; sj < suff.length; sj++) {
          t = t.split(suff[sj]).join('');
        }
      }
      return t.replace(/\s+/g, ' ').trim();
    };
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  console.log("Boost PFS Custom JS loaded!");
  // Add your custom JS below here:

  // Collection tabs slider
  collectionTabsMobileSlider(".collection-tabs");
  
});

const collectionTabsMobileSlider = (target = "") => {
  console.log("Initialize collection tabs slider for mobile");

  $(() => {
    var windowWidth = $(window).width();
    var isMobileOrTablet = windowWidth <= 1024;
    
    function initializeSlider() {
      const options = {
        mobileFirst: true,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        swipeToSlide: true,
        variableWidth: true,
        arrows: true,
        prevArrow: `<button type="button" class="slick-prev"><img height="30" width="30" loading="eager" src="//cdn.shopify.com/s/files/1/1051/6768/files/chevron.png?v=1688631156" alt="Slide previous" /></button>`,
        nextArrow: `<button type="button" class="slick-next"><img height="30" width="30" loading="eager" src="//cdn.shopify.com/s/files/1/1051/6768/files/chevron.png?v=1688631156{{ 'chevron.png' | asset_img_url }}" alt="Slide next" /></button>`
      };
      $(target).slick(options);
    }

    function destroySlider() {
      $(target).slick('unslick');
    }

    if (isMobileOrTablet) {
        initializeSlider();
    } else {
        destroySlider();
    }

    $(window).on('resize', function() {
        var newWindowWidth = $(window).width();
        var newIsMobileOrTablet = newWindowWidth <= 1024;

        if (newIsMobileOrTablet) {
          initializeSlider();
        } else {
          destroySlider();
        }
    });
  });
}